import type { QueryClient } from "@tanstack/react-query";
import type { SessionResponse } from "./client";

export const sessionQueryKey = (sessionId: string) => ["session", sessionId] as const;

/** Seeds the checkout's session query with the response already fetched by the cart. */
export function cacheSessionResponse(
  queryClient: QueryClient,
  sessionId: string,
  response: SessionResponse,
): void {
  queryClient.setQueryData(sessionQueryKey(sessionId), response);
}
